// extracted by mini-css-extract-plugin
export var logos = "logos-module--logos--uQmqt";
export var list = "logos-module--list--TC_6k";
export var jsAnimInit = "logos-module--jsAnimInit--SJ8n-";
export var item = "logos-module--item--_78BP";